import store, { persistStore } from '../../src/store'

const TEST_REDIRECT_URI = 'https://test.local' // Signicat requires https; see README.md

function isDigiDLocalDev () {
  return (typeof import.meta !== 'undefined' && import.meta.env?.MODE === 'development-personal') ||
    process.env.NODE_ENV === 'development-personal'
}

function getOAuthRedirectUri (hostUrl) {
  return isDigiDLocalDev() ? `${TEST_REDIRECT_URI}/meeting` : `${hostUrl}/meeting`
}

function base64UrlEncode (array) {
  return btoa(String.fromCharCode.apply(null, array))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')
}

function generateCodeVerifier () {
  const array = new Uint8Array(32)
  crypto.getRandomValues(array)
  return base64UrlEncode(array)
}

async function generateCodeChallenge (codeVerifier) {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier))
  return base64UrlEncode(new Uint8Array(digest))
}

async function generatePKCEPair () {
  const codeVerifier = generateCodeVerifier()
  const codeChallenge = await generateCodeChallenge(codeVerifier)
  return { codeVerifier, codeChallenge }
}

function generateRandomString (length) {
  const array = new Uint8Array(length)
  window.crypto.getRandomValues(array)
  return Array.from(array, (dec) => ('0' + dec.toString(16)).substr(-2)).join('')
}

export function clearSignicatSession () {
  store.commit('setParticipantMeetingState', null)
  store.commit('setCodeVerifier', null)
  store.commit('setSignicatRedirectUri', null)
}

export async function redirectToAuthorizationEndpoint (currentUrl, clientID, clientURL) {
  if (!currentUrl || !clientID || !clientURL) {
    return
  }

  const url = new URL(currentUrl)
  const { codeVerifier, codeChallenge } = await generatePKCEPair()
  const redirectUri = getOAuthRedirectUri(url.origin)
  const state = `${generateRandomString(16)}==${url.pathname}`

  store.commit('setCodeVerifier', codeVerifier)
  store.commit('setSignicatRedirectUri', redirectUri)
  store.commit('setParticipantMeetingState', state)
  persistStore()

  const authorizationUrl =
    `${clientURL}/connect/authorize?` +
    `client_id=${clientID}` +
    `&response_type=code` +
    `&redirect_uri=${encodeURIComponent(redirectUri)}` +
    `&state=${encodeURIComponent(state)}` +
    `&scope=${encodeURIComponent('openid profile nin email name')}` +
    `&code_challenge=${codeChallenge}` +
    `&code_challenge_method=S256` +
    `&prompt=login`

  window.location.href = authorizationUrl
}

export async function exchangeCodeForToken (currentUrl) {
  if (!currentUrl) {
    return null
  }

  const url = new URL(currentUrl)
  const code = url.searchParams.get('code')
  const state = url.searchParams.get('state')
  const storedState = store.getters.getParticipantMeetingState
  const codeVerifier = store.getters.getCodeVerifier
  const redirectUri = store.getters.getSignicatRedirectUri || getOAuthRedirectUri(url.origin)
  const meetingPath = state && state.includes('==') ? state.split('==')[1] : null

  if (!code || !state || state !== storedState || !codeVerifier || !meetingPath) {
    return null
  }

  return {
    meetingUrl: `${window.location.origin}${meetingPath}`,
    requestBody: {
      grant_type: 'authorization_code',
      redirect_uri: redirectUri,
      code,
      code_verifier: codeVerifier
    }
  }
}
